import { render, staticRenderFns } from "./PortfolioEmptyDefaultLayout.vue?vue&type=template&id=c6eb9f86&scoped=true"
import script from "./PortfolioEmptyDefaultLayout.vue?vue&type=script&lang=js"
export * from "./PortfolioEmptyDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6eb9f86",
  null
  
)

export default component.exports